export default __webpack_public_path__ + "static/media/hero_img.07d67ee0.png";